import { Button } from "@components/Button";
import { IFImg } from "@libs/utils/IFImg";
import styles from "./index.module.css";
import type { FC } from "react";

type Mode = "login" | "signup" | "link";

type Props = {
  mode: Mode;
  onGoogleClick: () => void;
  onAppleClick: () => void;
};

const actionLabels: Record<Mode, string> = {
  login: "ログイン",
  signup: "新規登録",
  link: "連携する",
};

const SocialAuthButtons: FC<Props> = ({
  mode,
  onGoogleClick,
  onAppleClick,
}) => {
  const actionLabel = actionLabels[mode];

  return (
    <div className={styles.oauthButtons}>
      <Button
        type="button"
        className={styles.googleBtn}
        onClick={onGoogleClick}
      >
        <img
          src={IFImg("/img/icon/google.svg")}
          width={24}
          height={24}
          alt=""
        />
        Googleで{actionLabel}
      </Button>
      <Button type="button" className={styles.appleBtn} onClick={onAppleClick}>
        <img src={IFImg("/img/icon/apple.svg")} width={24} height={24} alt="" />
        Appleで{actionLabel}
      </Button>
    </div>
  );
};

export default SocialAuthButtons;
